import { QRCodeSVG } from "qrcode.react";
import { usePresenter } from "./context";

export function joinHost(joinUrl: string): string {
  return joinUrl.replace(/^https?:\/\//, "");
}

export function JoinCard({ verb, size }: { verb: "Join" | "Vote"; size: "lg" | "md" }) {
  const { joinUrl, code } = usePresenter();
  const qrUrl = code ? `${joinUrl}/${code}` : joinUrl;
  return (
    <div className="join-card">
      <QRCodeSVG
        className="qr"
        value={qrUrl}
        size={size === "lg" ? 175 : 200}
        level="M"
        marginSize={0}
        fgColor="currentColor"
        bgColor="transparent"
        role="img"
        aria-label={`QR code to ${verb.toLowerCase()}: ${qrUrl}`}
      />
      <span className="join-card-text">
        {verb} at <b>{joinHost(joinUrl)}</b>
      </span>
      <span className="join-code" data-size={size} aria-label={code ? `Session code ${code}` : "No live session"}>
        {code ?? "----"}
      </span>
    </div>
  );
}
